import React, { createRef, RefObject, useContext, useEffect, useState } from 'react';
import { MapContext, UnitMapProps } from './UnitMapTypes';
import '../../../styles/UnitMap.css';
import StopIndex from './StopIndex';
import { Col, Container, Modal, ModalBody, Row } from 'reactstrap';
import { MapStopDto } from '../../../api/UnitMap';
const clearIcon = require('../../../images/close-menu.svg');
const UNIT_DEFAULT_COLOR = '#fff';

declare function unitmap(id: string, apiKey: string, options?: any[]): any;

const UnitMap = (props: UnitMapProps) => {
    const mapRef: RefObject<any> = createRef();
    const [mapSwap, setMapSwap] = useState(false);
    const context = useContext(MapContext);
    const stopIcon = (stop: MapStopDto) => {
        if (stop.stopNumber === 0) {
            if (stop.isAmenity) {
                return StopIndex.StartTourAlt;
            }
            return StopIndex.StartTour;
        }
        if (stop.stopNumber === context.configuration.stops.length - 1) {
            if (stop.isAmenity) {
                return StopIndex.EndTourAlt;
            }
            return StopIndex.EndTour;
        }
        if (stop.isAmenity) {
            return StopIndex.AltColorStops[stop.stopNumber - 1];
        }
        return StopIndex.Stops[stop.stopNumber - 1];
    };
    useEffect(() => {
        if (!context.map) {
            return;
        }
        context.map.levels().markers().removeAll();

        for (let stop of context.configuration.stops.slice().reverse()) {
            context.map
                .levels()
                .where({ floor: stop.floor ? stop.floor : '' })
                .markers()
                .add({
                    id: stop.stopNumber,
                    translate: [stop.x, stop.y],
                    cursor: 'pointer',
                    draggable: false,
                    size:
                        stop.stopNumber === 0 ||
                            stop.stopNumber === context.configuration.stops.length - 1
                            ? [96, 96]
                            : [64, 64],
                    icon: {
                        url: stopIcon(stop),
                        size:
                            stop.stopNumber === 0 ||
                                stop.stopNumber === context.configuration.stops.length - 1
                                ? [96, 96]
                                : [64, 64],
                        anchor:
                            stop.stopNumber === 0 ||
                                stop.stopNumber === context.configuration.stops.length - 1
                                ? [48, 48]
                                : [32, 32]
                    },
                    hitarea: null
                });
        }
    }, [context.map, context.configuration.stops, mapSwap, context.configuration]);

    useEffect(() => {
        let u = unitmap(mapRef.current, props.apiKey);

        if (!context.configuration.unitMapId) {
            return;
        }
        u.on('ready', () => {
            if (u.geo().isSupported()) {
                setInterval(() => {
                    updatePositionOnMap(u);
                }, 1000);
            }
        });
        u.load(context.configuration.unitMapId, () => {
            u.on('marker:click', (event: any) => {
                context.selectStop(event.marker.id);
            });
            setMapSwap(!mapSwap);
            context.setMap(u);
        });
    }, [context.configuration.unitMapId]);

    useEffect(() => {
        if (!context.map || !context.selectedFloor) {
            return;
        }
        context.map
            .levels()
            .has({ floor: true })
            .show()
            .except({ floor: context.selectedFloor })
            .hide();
    }, [context.map, mapSwap, context.selectedFloor]);

    useEffect(() => {
        if (!context.map) {
            return;
        }
        context.map.units().color(UNIT_DEFAULT_COLOR);

        for (let u of context.configuration.units) {
            context.map
                .units()
                .find(u.unitId)
                .color('#' + u.unitColor.hexColor);
        }
    }, [context.map, context.configuration.units, mapSwap, context.configuration]);
    let selectedStop =
        context.selectedStopIndex !== undefined
            ? context.configuration.stops[context.selectedStopIndex]
            : undefined;
    return (
        <div
            ref={mapRef}
            className={'unitmap'}
            onClick={e => {
                if (context.onMapClick) {
                    let rect = mapRef.current.getBoundingClientRect();
                    context.onMapClick(e.clientX - rect.x, e.clientY - rect.y);
                }
            }}
        >
            <Modal isOpen={selectedStop !== undefined} className="stop-detail">
                <ModalBody className="information">
                    <>
                        {selectedStop !== undefined && context.selectedStopIndex !== undefined ? (
                            <Container>
                                <Row className={'justify-content-between'}>
                                    <Col xs={10}>
                                        <h4>
                                            {stopNumberStringBuilder(
                                                context.selectedStopIndex,
                                                context.configuration.stops.length - 1
                                            )}
                                        </h4>
                                    </Col>
                                    <Col xs={2}>
                                        <img
                                            src={clearIcon}
                                            className={'close-icon'}
                                            onClick={() => {
                                                context.selectStop(undefined);
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <h5>{selectedStop.description}</h5>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {selectedStop.directions.split('\n').map((line, index) => (
                                            <h6 key={index}>{line}</h6>
                                        ))}
                                    </Col>
                                </Row>
                            </Container>
                        ) : (
                            <></>
                        )}
                    </>
                </ModalBody>
            </Modal>
        </div>
    );
};
function stopNumberStringBuilder(stopNumber: number, lastStop: number): string {
    if (stopNumber === 0) {
        return 'Start Tour';
    }
    if (stopNumber === lastStop) {
        return 'End Tour';
    }
    return 'Stop ' + stopNumber;
}
function updatePositionOnMap(unitMap: any) {
    navigator.geolocation.getCurrentPosition(position => {
        let locator = unitMap.locator();
        locator.translate(
            unitMap.geo().toLocal([position.coords.latitude, position.coords.longitude])
        );
    });
}
export default UnitMap;



// WEBPACK FOOTER //
// ./src/components/common/UnitMap/UnitMap.tsx